import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

const PcBox = DefaultBox;
const MobileBox = styled(DefaultBox)`
    padding: 0 10px 20px;
`;

export const GamePreviewInfoContainerDefaultBox = styledByDevice(PcBox, MobileBox);